#import "../../../../common/graphql/ExtractionTypes.graphql"

query ApprovalExtendedDocumentTypes(
  $entityApprovalId: UUID!

) {
  approvalExtendedDocumentTypes(
    entityApprovalId: $entityApprovalId
        orderBy: DOCUMENT_TYPE_ASC

  ) {
    nodes {
      id
      documentType
      isAccountingDocument
     ...ExtractionTypes

    }
  }
}
